import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)
import shop from './modules/shop'
import demand from './modules/demand'
import periphery from './modules/periphery'
import addressBook from './modules/addressBook'

/* Layout */
import Layout from '@/layout'

const router = new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Home',
          meta: {
            title: '考勤',
          },
          // component: () => import('@/views/shop/index.vue'),
		   // component: () => import('@/views/signIn/index.vue'),
		   component: () => import('@/views/signIn/clockIn.vue'),
        },
      ],
    },

    {
      path: '/zhIndex',
      component: Layout,
      children: [
        {
          path: '',
          name: 'zhHome',
          meta: {
            title: '考勤',
          },
          component: () => import('@/views/shop/zhIndex.vue'),
        },
      ],
    },
        {
      path: '/attendanceStatistics',
      component: Layout,
      children: [
        {
          path: '',
          name: 'attendanceStatistics',
          meta: {
            title: '考勤统计',
          },
          component: () => import('@/views/shop/attendanceStatistics.vue'),
        },
      ],
    },
    
    shop,
    demand,
    periphery,
    addressBook,
  ],
  mode: 'history',
})

// 动画效果
router.beforeEach((to, from, next) => {
  // console.log(to.path)
  // console.log(from.path)

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (
    to.path == from.path ||
    ((to.path == '/' || to.path == '/serve' || to.path == '/center') &&
      (from.path == '/' ||
        from.path == '/serve' ||
        from.path == '/login' ||
        from.path == '/village'))
  ) {
    store.commit('UPDATE_DIRECTION', 'none')
  } else if (
    to.path.indexOf(from.path) != -1 ||
    (from.name && to.name.indexOf(from.name) != -1)
  ) {
    store.commit('UPDATE_DIRECTION', 'forward')
  } else {
    store.commit('UPDATE_DIRECTION', 'reverse')
  }
  next()
})

export default router
